import { DISABLE_COGNITO_LOGIN, ENABLE_AUTH_UI_REDESIGN } from "../config/constants";
import ForgotPasswordNew from "../screens/auth/ForgotPasswordNew";
import LoginNew from "../screens/auth/LoginNew";
import PasswordResetNew from "../screens/auth/PasswordResetNew";
import MetaDashboard from "../screens/dashboard/MetaDashboard";
import PasswordForgot from "../screens/forgotPassword/ForgotPassword";
import CognitoLogin from "../screens/login/CognitoLogin";
import Login from "../screens/login/Login";
import LogOut from "../screens/logOut/LogOut";
import MappingInteraction from "../screens/mapping_interaction/MappingInteraction";
import NotificationList from "../screens/notificationList/NotificationList";
import PasswordReset from "../screens/passwordReset/PasswordReset";
import Unauthorized from "../screens/unauthorized/Unauthorized";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

// The redesigned auth screens (shadcn + Tailwind) only replace the form-based
// `/auth` flow. The Cognito Hosted UI path (`DISABLE_COGNITO_LOGIN === false`)
// is untouched by this flag.
const LoginRoute = DISABLE_COGNITO_LOGIN
  ? ENABLE_AUTH_UI_REDESIGN
    ? <LoginNew />
    : <Login />
  : <CognitoLogin />;
const PasswordResetRoute = ENABLE_AUTH_UI_REDESIGN ? <PasswordResetNew /> : <PasswordReset />;
const ForgotPasswordRoute = ENABLE_AUTH_UI_REDESIGN ? <ForgotPasswordNew /> : <PasswordForgot />;

export const CommonRoutes = [
  {
    path: "/auth",
    route: LoginRoute,
    protectRoutes: false
  },
  {
    path: "/logout",
    route: <LogOut />,
    protectRoutes: false
  },
  {
    path: "/password-reset",
    route: PasswordResetRoute,
    protectRoutes: false
  },
  {
    path: "/password-forgot",
    route: ForgotPasswordRoute,
    protectRoutes: false
  },
  {
    path: "/unauthorized",
    route: <Unauthorized />,
    protectRoutes: false
  },
  {
    path: "/",
    route: <MetaDashboard />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  },
  {
    path: "/mapping-interaction",
    route: <MappingInteraction />,
    protectRoutes: true,
    roleGrantAccess: [...supplierAccess, ...adminAccess, ...userAccess]
  },
  {
    path: "/notification",
    route: <NotificationList />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  }
];
